import { cssGenerator } from '@yola/ws-sdk';

const { breakpointNames, breakpoints } = cssGenerator.constants;

export const DESKTOP_BREAKPOINT = breakpointNames.EMPTY;
// The range the desktop device owns alone, as opposed to `DESKTOP_BREAKPOINT`
// which cascades down to every narrower device.
export const DESKTOP_ONLY_BREAKPOINT = breakpointNames.XL;
export const MOBILE_BREAKPOINT = `max-${breakpointNames.MD}`;
export const TABLET_BREAKPOINT = `max-${breakpointNames.XL}`;

export const XL_BREAKPOINT_PX = parseInt(breakpoints.xl, 10);
export const MD_BREAKPOINT_PX = parseInt(breakpoints.md, 10);
